import { AmplitudeEvents as AmplitudeEvents$1, AmplitudeProperties as AmplitudeProperties$1 } from '@packlink/metrics';

let AmplitudeEventsCustomsForm = /*#__PURE__*/function (AmplitudeEventsCustomsForm) {
  AmplitudeEventsCustomsForm["SELECT_CUSTOMS_REASONS_TO_EXPORT"] = "Select customs reasons to export";
  return AmplitudeEventsCustomsForm;
}({});
let AmplitudePropertiesCustomsForm = /*#__PURE__*/function (AmplitudePropertiesCustomsForm) {
  AmplitudePropertiesCustomsForm["REASON_TO_EXPORT"] = "Reason to export";
  return AmplitudePropertiesCustomsForm;
}({});
const AmplitudeEvents = {
  ...AmplitudeEvents$1,
  ...AmplitudeEventsCustomsForm
};
const AmplitudeProperties = {
  ...AmplitudeProperties$1,
  ...AmplitudePropertiesCustomsForm
};

export { AmplitudeEvents, AmplitudeEventsCustomsForm, AmplitudeProperties, AmplitudePropertiesCustomsForm };
//# sourceMappingURL=amplitude.js.map
